import React__default, { Component } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import MessageBubbleText from '../MessageBubbleText/index.js';
import ChatActions from '../ChatActions/index.js';

var MessageTextPart =
/** @class */
function (_super) {
  __extends(MessageTextPart, _super);

  function MessageTextPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageTextPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageTextPart.prototype.getMessagePartText = function (messagePart) {
    switch (messagePart.type) {
      case 'TEXT':
      case 'SHORTENED_TEMPLATE':
      case 'TEMPLATE':
      case 'TEMPLATE_TEXT':
        return messagePart.body.text;

      default:
        throw new Error('Could not decode message part');
    }
  };

  MessageTextPart.prototype.render = function () {
    var text = this.getMessagePartText(this.props.part);
    var message = this.getMessageFromPart(this.props.part);
    return React__default.createElement(ChatActions, {
      messagePart: this.props.part
    }, React__default.createElement(MessageBubbleText, {
      message: message,
      myself: this.props.myself
    }, text));
  };

  return MessageTextPart;
}(Component);

export default MessageTextPart;
//# sourceMappingURL=index.js.map
